module.exports = __webpack_public_path__ + "static/img/expoAi.af9f9f58.png";